import { createFileRoute } from '@tanstack/react-router';
import { ResetPassword } from '@/pages/reset-password';
import z from '@/lib/zod';

export const Route = createFileRoute('/password-reset')({
  component: ResetPassword,
  validateSearch: z.object({ token: z.string().nullish() }),
});
